export const X_AXIS_HEIGHT = 50;
